var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.75C6.5 0.551088 6.42098 0.360322 6.28033 0.21967C6.13968 0.0790175 5.94891 0 5.75 0C5.55109 0 5.36032 0.0790175 5.21967 0.21967C5.07902 0.360322 5 0.551088 5 0.75V5H0.75C0.551088 5 0.360322 5.07902 0.21967 5.21967C0.0790175 5.36032 0 5.55109 0 5.75C0 5.94891 0.0790175 6.13968 0.21967 6.28033C0.360322 6.42098 0.551088 6.5 0.75 6.5H5V10.75C5 10.9489 5.07902 11.1397 5.21967 11.2803C5.36032 11.421 5.55109 11.5 5.75 11.5C5.94891 11.5 6.13968 11.421 6.28033 11.2803C6.42098 11.1397 6.5 10.9489 6.5 10.75V6.5H10.75C10.9489 6.5 11.1397 6.42098 11.2803 6.28033C11.421 6.13968 11.5 5.94891 11.5 5.75C11.5 5.55109 11.421 5.36032 11.2803 5.21967C11.1397 5.07902 10.9489 5 10.75 5H6.5V0.75Z",
    fill: "#0C2C40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.dfa0a2be65c15bcdd123ddb6d5ab5162.svg";
export { ForwardRef as ReactComponent };